import { Asset as _Asset } from './asset';
import { AssetActions } from './asset.actions';
import { AssetCheckbox } from './asset.checkbox';
import { AssetContextMenu } from './asset.context-menu';
import { AssetImage } from './asset.image';
import { AssetLabel } from './asset.label';

const Asset = Object.assign(_Asset, {
  Image: AssetImage,
  Actions: AssetActions,
  Checkbox: AssetCheckbox,
  ContextMenu: AssetContextMenu,
  Label: AssetLabel,
});

export * from './asset.context-provider';
export { AssetTileAction, AssetTileVariant } from './asset.actions';
export { LABELED_BUTTON_TOP_OFFSET } from './constants';
export type { AssetActionsProps } from './asset.actions';
export type { AssetCheckboxProps } from './asset.checkbox';
export type { AssetImageOverlayProps, AssetImageProps } from './asset.image';
export { Asset };
export { AssetDraggable } from './asset.draggable';
export { AssetDraggableWithHandle } from './asset.handle-draggable';
export type { AssetDraggableProps, AssetProps } from './types';
